import {
  first58ocm7j58k3q as first,
  drop3na99dw9feawf as drop,
  toList3jhuyej2anx2q as toList,
  plus1di085adi7f7m as plus,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  _Result___get_value__impl__bjfvqg316j9v81zgqwq as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2lptaeb4c2198 as _Result___get_isFailure__impl__jpiriv,
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance3smx0snb237u2 as Companion_getInstance } from '../../../../types-types-internal/kotools/types/internal/ErrorMessage.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ListSerializer1hxuk9dx5n9du as ListSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { serializationError3bsuwdsvfqinr as serializationError } from '../../../../types-types-internal/kotools/types/internal/Errors.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _NotEmptyList___init__impl__99zwhj(elements) {
  return elements;
}
function _get_elements__k8byyc($this) {
  return $this;
}
function _NotEmptyList___get_head__impl__zp2sw($this) {
  return first(_get_elements__k8byyc($this));
}
function _NotEmptyList___get_tail__impl__3z1zi8($this) {
  // Inline function 'kotlin.Result.getOrNull' call
  var this_0 = toNotEmptyList(drop(_get_elements__k8byyc($this), 1));
  var tmp = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  return tmp == null ? null : tmp.h29_1;
}
function NotEmptyList__toList_impl_nbkblo($this) {
  return _get_elements__k8byyc($this);
}
function NotEmptyList__toString_impl_vyyy95($this) {
  return toString(_get_elements__k8byyc($this));
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      i29(elements) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        var isValid = !elements.n1();
        var tmp2_require_this = Companion_getInstance();
        // Inline function 'kotlin.require' call
        if (!isValid) {
          var message = tmp2_require_this.d29();
          throw IllegalArgumentException().n2(toString(message));
        }
        return _NotEmptyList___init__impl__99zwhj(elements);
      }
      j29(typeSerial0) {
        return new (NotEmptyListSerializer())(typeSerial0);
      }
      n20(typeParamsSerializers) {
        return this.j29(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function NotEmptyList__hashCode_impl_a7t1ga($this) {
  return hashCode($this);
}
function NotEmptyList__equals_impl_vb9j0q($this, other) {
  if (!(other instanceof NotEmptyList()))
    return false;
  var tmp0_other_with_cast = other instanceof NotEmptyList() ? other.h29_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var NotEmptyListClass;
function NotEmptyList() {
  if (NotEmptyListClass === VOID) {
    class $ {
      constructor(elements) {
        this.h29_1 = elements;
      }
      toString() {
        return NotEmptyList__toString_impl_vyyy95(this.h29_1);
      }
      hashCode() {
        return NotEmptyList__hashCode_impl_a7t1ga(this.h29_1);
      }
      equals(other) {
        return NotEmptyList__equals_impl_vb9j0q(this.h29_1, other);
      }
    }
    initMetadataForClass($, 'NotEmptyList', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    NotEmptyListClass = $;
  }
  return NotEmptyListClass;
}
function toNotEmptyList(_this__u8e3s4) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    var elements = toList(_this__u8e3s4);
    // Inline function 'kotlin.Companion.success' call
    var value = new (NotEmptyList())(Companion_instance_0.i29(elements));
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function _get_delegate__idh0py($this) {
  var tmp0 = $this.k29_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('delegate', 1, tmp, NotEmptyListSerializer$_get_delegate_$ref_hejoxb(), null);
  return tmp0.n3();
}
function NotEmptyListSerializer$_get_delegate_$ref_hejoxb() {
  return (p0) => _get_delegate__idh0py(p0);
}
function NotEmptyListSerializer$_get_descriptor_$ref_pqubut() {
  return (p0) => p0.a1n();
}
var NotEmptyListSerializerClass;
function NotEmptyListSerializer() {
  if (NotEmptyListSerializerClass === VOID) {
    class $ {
      constructor(elementSerializer) {
        var tmp = this;
        tmp.k29_1 = lazy(() => ListSerializer(elementSerializer));
        var tmp_0 = this;
        tmp_0.l29_1 = lazy(() => _get_delegate__idh0py(this).a1n());
      }
      a1n() {
        var tmp0 = this.l29_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, NotEmptyListSerializer$_get_descriptor_$ref_pqubut(), null);
        return tmp0.n3();
      }
      m29(encoder, value) {
        var elements = NotEmptyList__toList_impl_nbkblo(value);
        encoder.k1t(_get_delegate__idh0py(this), elements);
      }
      b1n(encoder, value) {
        return this.m29(encoder, value instanceof NotEmptyList() ? value.h29_1 : THROW_CCE());
      }
      n29(decoder) {
        // Inline function 'kotlin.Result.getOrNull' call
        var this_0 = toNotEmptyList(decoder.q1r(_get_delegate__idh0py(this)));
        var tmp = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
        var tmp0_elvis_lhs = tmp == null ? null : tmp.h29_1;
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new (NotEmptyList())(tmp_1)) == null) {
          serializationError(Companion_getInstance().d29());
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        return tmp_0;
      }
      c1n(decoder) {
        return new (NotEmptyList())(this.n29(decoder));
      }
    }
    initMetadataForClass($, 'NotEmptyListSerializer', VOID, VOID, [KSerializer()]);
    NotEmptyListSerializerClass = $;
  }
  return NotEmptyListSerializerClass;
}
function notEmptyListOf(head, tail) {
  var elements = plus(listOf(head), tail);
  return Companion_instance_0.i29(elements);
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  NotEmptyList__hashCode_impl_a7t1ga as NotEmptyList__hashCode_impl_a7t1ga1icu5nxpmmumo,
  _NotEmptyList___get_head__impl__zp2sw as _NotEmptyList___get_head__impl__zp2swu0zs1qn8pqty,
  _NotEmptyList___get_tail__impl__3z1zi8 as _NotEmptyList___get_tail__impl__3z1zi81rb3cv4yxqpfw,
  NotEmptyList__toList_impl_nbkblo as NotEmptyList__toList_impl_nbkblo1xb1zjd6musb4,
  NotEmptyList__toString_impl_vyyy95 as NotEmptyList__toString_impl_vyyy953tw060zmkvhkj,
  NotEmptyListSerializer as NotEmptyListSerializerma4riwuzrd1z,
  NotEmptyList as NotEmptyList3lrchpxsqrpb2,
  notEmptyListOf as notEmptyListOf1z9dexvzyo0sz,
  toNotEmptyList as toNotEmptyList14g9ksf17trkx,
};
//endregion

//# sourceMappingURL=NotEmptyList.mjs.map
